export default {
      id: "doctor-usage",
      viewBox: "0 0 19.953 27.996",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#doctor",
      toString: function () {
        return this.url;
      }
    }